import React from 'react'
import { useHistory, useParams } from "react-router-dom";
import { styled } from '@mui/material/styles';
import {Dialog,DialogContent,Typography} from "@mui/material";
import MultipleFiles from "../../myfin_v2/assets/icons/MultipleFiles.png";
import MultipleSheets from "../../myfin_v2/assets/icons/MultipleSheets.png";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(3),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    borderRadius: '20px',
    minHeight: 'auto'
  },
  '*': {
    fontFamily: "'DM Sans', sans-serif !important"
  }
}));
const isNewUI = true;

const SelectSheetType = ({ open, setOpen , setsingleFormat, presetId, onSelectType}) => {
  let history = useHistory();
  
  // const SelectType = (type) => {
  //   setOpen(false);
  //   setsingleFormat(true);
  //   history.push(`/preset/upload-tb/${type}/${presetId}`);
  // };
  const params = useParams();
  const SelectType = (type) => {
    setOpen(false);
    if (onSelectType) {
      onSelectType(type);
    } else {
      const id = presetId || params?.presetId;
      setsingleFormat(true);
      history.push(`/preset/upload-tb/${type}/${id}`);
    }
  };

  return (
    <>
      <BootstrapDialog
        onClose={() => setOpen(false)}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="md"
      >
        <DialogContent dividers>
          {isNewUI ? (


  <div style={{ display: "flex", justifyContent: "center", height: "100%" }}>
  <div style={{ width: "600px",display: "flex", flexDirection: "column", justifyContent: "space-between" }}>

    <div className="d-flex justify-content-between align-items-center pb-3 mb-2" style={{ borderBottom: "1px solid #EAEAEA", margin: "0 -24px", padding: "0 24px" }}>
      <h5 style={{ margin: 0, fontSize: "20px", color: "#183930" }}>Upload Trial Balance (Excel)</h5>
      <span style={{ cursor: "pointer", fontSize: "16px", color: "#777" }} onClick={() => setOpen(false)}>✕</span>
    </div>

    <div className="d-flex justify-content-between" style={{ marginTop: "10px", gap: "16px", flexGrow: 1 }}>

      <div
        style={{
          width: "90%",
          border: "1px solid #C2E6D1",
          borderRadius: "16px",
          cursor: "pointer",
          overflow: "hidden",
          marginTop: "15px",
          display: "flex",
          flexDirection: "column"
        }}
        onClick={() => SelectType('single')}
      >
        <div style={{ height: "180px", background: "#ffffff", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <img src={MultipleFiles} alt="Multiple Files" style={{ maxHeight: "90%", maxWidth: "90%", objectFit: "contain" }} />
        </div>
        <div style={{ padding: "10px 14px", background: "#f4faf5", textAlign: "left", flexGrow: 1 }}>
          <div style={{ fontSize: "18px", color: "#183930", marginBottom: "4px" }}>
            Upload as multiple excel <br/> files
          </div>
          <div style={{ fontSize: "14px", color: "#809790", lineHeight: "1.2" }}>
            Make sure only one sheet is present if one file is uploaded at a time
          </div>
        </div>
      </div>

      <div
        style={{
          width: "90%",
          border: "1px solid #C2E6D1",
          borderRadius: "16px",
          cursor: "pointer",
          overflow: "hidden",
          marginTop: "15px",
          display: "flex",
          flexDirection: "column"
        }}
        onClick={() => SelectType('multi')}
      >
        <div style={{ height: "180px", background: "#ffffff", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <img src={MultipleSheets} alt="Multiple Sheets" style={{ maxHeight: "90%", maxWidth: "90%", objectFit: "contain" }} />
        </div>
        <div style={{ padding: "10px 14px", background: "#f4faf5", textAlign: "left", flexGrow: 1 }}>
          <div style={{ fontSize: "18px", color: "#183930", marginBottom: "4px" }}>
            Upload as multiple excel sheets
          </div>
          <div style={{ fontSize: "14px", color: "#809790", lineHeight: "1.2" }}>
            Make sure only one sheet is present if one file is uploaded at a time
          </div>
        </div>
      </div>

    </div>

  </div>
</div>

  ) : (
          <>
          <div className="d-flex justify-content-center mt-4 font-sans"><h1>Choose One</h1></div>
          <div className="d-flex justify-content-between mt-3">
            <button onClick={()=>SelectType('single')} className="card ml-5 w-50 mr-3 py-3">
              <div className="card-body ">
                <Typography className="card-text text-center">Uploaded as Multiple excel files</Typography>
              </div>
            </button>
            <button onClick={()=>SelectType("multi")} className="card mr-5 w-50 ml-3 py-3">
              <div className="card-body">
                <Typography className="card-text text-center">Uploaded as Multiple excel Sheets</Typography>
              </div>
            </button>
          </div>

          <Typography align='center' className='custom-common-theme-text-color mb-4'>
            <i className="fas fa-info-circle icon-info mr-2 mt-5"></i>
            Make sure only one sheet is present if one file is uploaded at a time
          </Typography>
          </>
        )}
        </DialogContent>
      </BootstrapDialog>
    </>
  )
}

export default SelectSheetType;